import Svg, {Path} from 'react-native-svg';

const RightArrowIcon = () => (
  <Svg width="18" height="24" viewBox="0 0 18 24" fill="none" strokeWidth={2}>
    <Path d="M6 17.5L11.5 12L6 6.5" stroke="#B7B7B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </Svg>
);

export default RightArrowIcon;
